import { createSlice } from '@reduxjs/toolkit';
import OrganizationsService from 'services/OrganizationsService';
import { toast } from './notificationReducer';
import { organizationsTexts } from 'locale/es';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    setOrganizations(state, action) {
      const { data } = action.payload;

      return { ...state, data, loading: false, error: null };
    },
    appendOrganizations(state, action) {
      const { data } = action.payload;

      return {
        ...state,
        data: [...state.data, data],
        loading: false,
        error: null,
      };
    },
    updateOrganizations(state, action) {
      const { data } = action.payload;

      const updatedOrganizations = state.data.map((organizations) =>
        organizations.id !== data.id ? organizations : data
      );

      return {
        ...state,
        data: updatedOrganizations,
        loading: false,
        error: null,
      };
    },
    deleteOrganization(state, action) {
      const newDataState = state.data.filter((organization) => organization.id !== action.payload)

      return { ...state, data: newDataState, loading: false, error: null, }
    },
    setOrganizationsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setOrganizationsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetOrganizationsState(state, action) {
      return initialState;
    },
  },
});

export const { setOrganizations, appendOrganizations, updateOrganizations, deleteOrganization, setOrganizationsLoading, setOrganizationsError, resetOrganizationsState } = organizationsSlice.actions;

export const initializeOrganizations = () => {
  return async (dispatch) => {
    try {
      dispatch(setOrganizationsLoading());

      const { data } = await OrganizationsService.getOrganizations();
      dispatch(setOrganizations({ data }));
    } catch (error) {
      console.error(error);
      dispatch(
        setOrganizationsError({
          message: error.message,
          status: error.response?.status,
        })
      );
      dispatch(toast(organizationsTexts.LOADING_ERROR, 'error'));
    }
  };
};

export const createOrganization = (organizationObject) => {
  return async (dispatch, getState) => {
    try {
      const { data } = await OrganizationsService.create(organizationObject);
      dispatch(appendOrganizations({ data }));
      dispatch(toast(organizationsTexts.CREATED, 'success'));
    } catch (error) {
      console.error(error);
      dispatch(
        setOrganizationsError({
          message: error.message,
          status: error.response?.status,
        })
      );
      throw error;
    }
  };
};

export const updateOrganizationsAction = (organizationId, organizationObject) => {
  return async (dispatch) => {
    try {
      const { data } = await OrganizationsService.update(organizationId, organizationObject);
      dispatch(updateOrganizations({ data }));
      dispatch(toast(organizationsTexts.EDITED, 'success'));
    } catch (error) {
      console.error(error);
      dispatch(
        setOrganizationsError({
          message: error.message,
          status: error.response?.status,
        })
      );
      throw error;
    }
  };
};

export const deleteOrganizationAction = (organizationId) => {
  return async (dispatch) => {
    try {
      await OrganizationsService.remove(organizationId)
      dispatch(deleteOrganization(organizationId))
      dispatch(toast(organizationsTexts.DELETED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setOrganizationsError({ message: error.message, status: error.response?.status }));
      dispatch(toast(organizationsTexts.DELETED_ERROR, 'error'))
    }
  }
}

export default organizationsSlice.reducer;